import { FC } from 'react';

import HorizontalPagination from '../horizontal-paginator';

import { ModalContainer } from '../modal-container';

import { useAppSelector } from '../../hooks/redux';

import { getIsActiveOrScheduledProps } from '../../utils/tariffUtils';

import { ITariff } from '../../store/tariff.slice';

import { getTariffCardComponent } from './get-tariff-card-component';

export interface ITariffCardDetailsModalProps {
  tariffs: ITariff[];
  onClose?: () => void;
  onByClick?: (tariff: ITariff) => void;
  tariffToolsMaxCount: number;
  index?: number;
  activeTariffId?: string;
  activeEndDate?: Date;
}

export const TariffCardDetailsModal: FC<ITariffCardDetailsModalProps> = ({
  tariffs,
  onClose,
  onByClick,
  tariffToolsMaxCount,
  index,
  activeTariffId,
  activeEndDate,
}) => {
  const tariffState = useAppSelector((state) => state.tariffSlice);

  return (
    <ModalContainer clickOutsideMode={true} title="Подробнее о тарифе:" onClose={onClose}>
      <HorizontalPagination itemWidth={270} bringToViewIndex={index}>
        {tariffs.map((t, index) => {
          const TariffCardComponent = getTariffCardComponent(t.package_type);
          const isActive = activeTariffId ? t.id === activeTariffId : false;

          return (
            <TariffCardComponent
              tariff={t}
              displayMode={'full'}
              key={index}
              onSelectClick={() => onByClick?.(t)}
              tariffToolsMaxCount={tariffToolsMaxCount}
              {...(activeTariffId
                ? { active: isActive, start_end_date: isActive ? activeEndDate : undefined }
                : getIsActiveOrScheduledProps(tariffs[index].id, tariffState.current, tariffState.scheduled))}
            />
          );
        })}
      </HorizontalPagination>
    </ModalContainer>
  );
};
